/** @format */

import { FormWrap } from "../../layouts/FormWrap";
import { Box } from "../../layouts/Box";
import { TextField, Button, ErrorMessage, BackButton, LinkByAgent } from "../../ui-parts";
import { ChangeEventHandler, MouseEventHandler } from "react";
import { useLocation } from "react-router-dom";
import { useContext } from "react";
import { Context } from "../../../stores/Provider";

const ResetPasswordMailElement = ({
  setEmailHandler,
  sendEmailHandler,
  ErrMsg,
  ApiErrMsg,
  changePassword,
}: {
  setEmailHandler: ChangeEventHandler<HTMLInputElement>;
  sendEmailHandler: MouseEventHandler<HTMLButtonElement>;
  ErrMsg: string;
  ApiErrMsg?: string;
  changePassword?: boolean;
}) => {
  const passPhrase = changePassword ? "パスワード変更" : "パスワード再設定";
  const location = useLocation();
  const { state } = useContext(Context);
  const agentPath = state.agentPath;
  const from = location.state?.from;
  const from_romove_agent_path = from.replace(agentPath, "");

  let backText = "ダッシュボードへ戻る";
  let backLink = "/dashboard";

  if (from_romove_agent_path && from_romove_agent_path === "/entry_select") {
    backText = "申込選択へ戻る";
    backLink = "/entry_select";
  }

  return (
    <>
      {changePassword && (
        <div className="mb32 align_right">
          <BackButton>
            <LinkByAgent to={backLink}>{backText}</LinkByAgent>
          </BackButton>
        </div>
      )}
      <FormWrap>
        <div className="align_center">
          <h1 className="mt0 mb0">{passPhrase}</h1>
          <p className="mt16 align_left">ご登録のメールアドレスを入力してください。{passPhrase}のURLを送信します。</p>
        </div>
        <ErrorMessage ApiErrMsg={ApiErrMsg} />
        <TextField
          mt={20}
          onChange={setEmailHandler}
          iserror={ErrMsg}
          id="textfield1"
          label="メールアドレス"
          placeholder="user@cardservice.co.jp"
          fullwidth
        />
        <Box mt={32}>
          <Button variant="primary" fullwidth onClick={sendEmailHandler}>
            {passPhrase}メールを送信する
          </Button>
        </Box>
      </FormWrap>
    </>
  );
};

export default ResetPasswordMailElement;
